import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { deleteFaqAPI } from "Api/faqAPI";
import { consoleLog } from "helpers";

const EditOrDeleteFAQBtn = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    setfaqFormData,
    initialFaqFormState,
    setFetchFaq,
    setIsOpenFaqEditForm,
  } = useGlobalContext();
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await deleteFaqAPI(
      { id: props.cell.row.original.id },
      () => {},
      token
    );
    if (response) {
      toast.success(`FAQ deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchFaq(true);
    }
    if (!response) {
      toast.error("FAQ deletion failed");
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    consoleLog([props.cell?.row?.original,'props.cell?.row?.origina'])
    setfaqFormData(


      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
          }
        : {
            ...initialFaqFormState,
          }

    );
    setIsOpenFaqEditForm(true);
    consoleLog([props, "props"]);
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default EditOrDeleteFAQBtn;
